import { render, staticRenderFns } from "./ResumoMovimentacao.vue?vue&type=template&id=5a85333c"
import script from "./ResumoMovimentacao.vue?vue&type=script&lang=ts"
export * from "./ResumoMovimentacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports